module.exports = function getResource(label, vars = []) {
    const resources = {
        back: 'Retour',
        retake: 'Reprendre',
        saveAndContinue: 'Enregistrer et continuer',
        signInToSave: 'Ouvrir une session pour enregistrer'
    };

    return resources[label];
};
